function updateSCDeliveryDates(){
  const today=new Date();
  const formatter=new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit',year:'numeric'});
  document.querySelectorAll('[data-sc-delivery-days]').forEach(time=>{
    const days=Number(time.dataset.scDeliveryDays);
    if(!Number.isFinite(days))return;
    const date=new Date(today.getFullYear(),today.getMonth(),today.getDate()+days,12);
    time.textContent=formatter.format(date);
    time.dateTime=[date.getFullYear(),String(date.getMonth()+1).padStart(2,'0'),String(date.getDate()).padStart(2,'0')].join('-');
  });
}
function initSCSite(){
  updateSCDeliveryDates();
  for(const root of document.querySelectorAll('.sc-site')){
    if(root.dataset.ready)continue;root.dataset.ready='true';
    root.addEventListener('click',e=>{const opener=e.target.closest('[data-sc-open]');if(opener){const dialog=document.getElementById(opener.dataset.scOpen);if(dialog){dialog.showModal();dialog.querySelector('input[type=search]')?.focus();}}const close=e.target.closest('[data-sc-close]');if(close)close.closest('dialog').close();if(e.target.tagName==='DIALOG'){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}if(e.target.closest('.sc-menu-panel a'))root.querySelector('.sc-menu').open=false;});
    if(matchMedia('(max-width:749px)').matches)root.querySelectorAll('.sc-footer details').forEach(d=>d.open=false);
  }
  for(const form of document.querySelectorAll('.contact-form__form')){if(form.dataset.scReady)continue;form.dataset.scReady='true';const topic=form.querySelector('[data-sc-topic]'),order=form.querySelector('.sc-contact-order');if(topic&&order){const update=()=>{order.hidden=!['Order enquiry','Returns'].includes(topic.value);order.querySelector('input').disabled=order.hidden;};topic.addEventListener('change',update);update();}}
}
initSCSite();document.addEventListener('shopify:section:load',initSCSite);

document.addEventListener("click", e => { const button=e.target.closest("[data-size-open],[data-size-close]"); if(!button)return; const dialog=button.closest("[data-sc-size]")?.querySelector("dialog"); if(!dialog)return; if(button.hasAttribute("data-size-open"))dialog.showModal(); else dialog.close(); });

window.addEventListener('pageshow',updateSCDeliveryDates);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)updateSCDeliveryDates();});

// Keep the custom navigation in sync with confirmed Shopify cart updates.
let scCartReadVersion = 0;
function renderSCCartCount(count) {
  document.querySelectorAll('a.sc-cart').forEach(link => {
    link.setAttribute('aria-label', link.dataset.scCartLabel.replace('__COUNT__', String(count)));
    const text = link.querySelector('[data-sc-cart-text]');
    if (text) text.textContent = link.dataset.scCartText.replace('__COUNT__', String(count));
    const badge = link.querySelector('[data-sc-cart-count]');
    if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
  });
  const summary = document.querySelector('[data-sc-cart-summary]');
  if (summary) summary.textContent = summary.dataset.scCartSummaryTemplate.replace('__COUNT__', String(count));
}
async function refreshSCCartCount() {
  const link = document.querySelector('a.sc-cart');
  if (!link) return;
  const version = ++scCartReadVersion;
  const response = await fetch(link.getAttribute('href') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!response.ok) throw new Error('Unable to refresh shopping bag');
  const cart = await response.json();
  if (version === scCartReadVersion) renderSCCartCount(cart.item_count);
}
document.addEventListener('click', event => {
  const dismiss = event.target.closest('[data-sc-cart-dismiss]');
  if (dismiss) dismiss.closest('dialog').close();
});
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
    try {
      const result = await event.promise;
      const detail = result?.detail;
      if (Array.isArray(detail?.items)) {
        ++scCartReadVersion;
        renderSCCartCount(detail.items.reduce((count, item) => count + Number(item.quantity || 0), 0));
      } else {
        await refreshSCCartCount();
      }
      if (detail?.source === 'product-form-component' && detail.didError === false) {
        const dialog = document.getElementById('sc-cart-feedback');
        if (dialog && !dialog.open) dialog.showModal();
      }
    } catch (error) {
      // Failed additions must not show a success message or increase the count.
      if (error?.name !== 'AbortError') console.warn('[shopping-bag]', error);
    }
  });
}).catch(error => console.warn('[shopping-bag]', error));
window.addEventListener('pageshow', () => refreshSCCartCount().catch(() => {}));
